// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
var __webpack_exports__ = __webpack_require__.O(undefined, ["blocks/site-poll/style-view"], () => (__webpack_require__("./src/blocks/site-poll/view.js")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
